import { render, staticRenderFns } from "./all-policy.vue?vue&type=template&id=2ea891a1&scoped=true&"
import script from "./all-policy.vue?vue&type=script&lang=js&"
export * from "./all-policy.vue?vue&type=script&lang=js&"
import style0 from "./all-policy.vue?vue&type=style&index=0&id=2ea891a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea891a1",
  null
  
)

export default component.exports